export enum MARKETING_OFFER_TYPE {
  REFUND_BY_WIRE_TRANSFER = 'RefundByWireTransfer',
  REFUND_ON_PAYMENT_METHOD = 'RefundOnPaymentMethod',
  GIFT_CARD = 'GiftCard',
  VOUCHER = 'Voucher',
  EXCHANGE_ON_SELLER_STOCK = 'ExchangeOnSellerStock',
  CREDIT_NOTE = 'CreditNote',
  CASH_REGISTER = 'CashRegister',
  CHECK = 'Check',
  DIGITAL_GIFT_CARD = 'DigitalGiftCard',
  LENDER = 'Lender',
  LOYALTY_CARD = 'LoyaltyCard',
  PAYEMENT_SERVICE = 'PaymentService',
  OTHER = 'Other',
  NOT_SET = 'NotSet',
  WIRE_TRANSFER = 'WireTransfer',
  INTEGRATED_PROVIDER = 'IntegratedProvider',
}

export enum MARKETING_OFFER_STATE {
  COMPLETED = 'Completed',
  CANCELLED = 'Cancelled',
  FAILED = 'Failed',
  ISSUED = 'Issued',
  PENDING = 'Pending',
}

export enum MARKETING_OFFER_TARGET {
  PAYMENT = 'Payment',
  ORDER = 'Order',
}
